export const VideoProductionStyle = {
    TESTIMONIAL: 'Testimonial',
    BOOMERANG: 'Boomerang',
    STORIES: 'Stories',
    STOP_MOTION: 'Stop Motion',
    FANCY_STOP_MOTION: 'Adv. Stop Motion',
    NARRATIVE: 'Narrative',
    TUTORIAL: 'Tutorial'
};



// WEBPACK FOOTER //
// ./common/language/content_component/video_production_style.js